module.exports = __webpack_public_path__ + "static/media/signage-industrial-img16.6768c386.jpg";